import { Heading } from '@chakra-ui/react';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';

import { maxTablet } from '@/constants/vars.constants';
import { useFiltersQuery } from '@/hooks/used-cars/filters-query.hook';
import { getVehicleIdPath } from '@/hooks/used-cars/query-params.hook';
import { useVehicles } from '@/hooks/used-cars/vehicles.hook';
import { useWindowSize } from '@/hooks/window-size.hook';
import { makeKiaFirstVehicles } from '@/services/filters/filters.service';
import { Vehicle, VehicleType } from '@/types/used-cars/used-cars.types';

import { BlockWrapper } from '../block-wrapper/block-wrapper';
import { CarTile } from '../car-tile/car-tile';
import { SliderSlick } from '../slider/slider';

import styles from './popular-cars.module.scss';

export const PopularCars: React.FC<{
  description: string;
  descriptionDemo: string;
}> = () => {
  const { vehicles } = useVehicles();
  const { width } = useWindowSize();
  const isTablet = width <= maxTablet;
  const [sliderDom, setSliderDom] = useState<any | null>(null);
  const [popularVehicles, setPopularVehicles] = useState<Vehicle[]>([]);
  const { activeCarType } = useFiltersQuery();

  useEffect(() => {
    const vehiclesArray = [...vehicles];
    const popularCars = makeKiaFirstVehicles(
      vehiclesArray.sort((a, b) =>
        Number(a.popularity) < Number(b.popularity)
          ? 1
          : Number(b.popularity) < Number(a.popularity)
            ? -1
            : 0,
      ),
    );

    setPopularVehicles(popularCars.splice(0, 15));
  }, [vehicles]);

  useEffect(() => {
    if (sliderDom) {
      const slickWrap = document.querySelector(
        '#used-car-slider-landing-popular',
      );
      const slickList: HTMLElement = slickWrap?.querySelector(
        '.slick-list',
      ) as HTMLElement;

      if (!slickList) return;

      slickList.style.marginRight = isTablet ? '-90%' : '0';
    }
  }, [sliderDom]);

  return (
    <div className={styles.wrapper}>
      <BlockWrapper>
        <div className={styles.sectionWrapper}>
          <div className={styles.titleWrap}>
            <Heading className={styles.title} fontFamily="KiaSignature" as="h2">
              {activeCarType == VehicleType.Demo
                ? 'Most Popular Demo Used Cars'
                : 'Most Popular Used Cars'}
            </Heading>
          </div>
          <div className={styles.flex}>
            {activeCarType == VehicleType.Demo ? (
              <div
                className={styles.text}
                dangerouslySetInnerHTML={{ __html: '' }}
              ></div>
            ) : (
              <div
                className={styles.text}
                dangerouslySetInnerHTML={{ __html: '' }}
              ></div>
            )}
          </div>
          {popularVehicles?.length > 0 ? (
            <SliderSlick
              setSliderDom={setSliderDom}
              sliderLength={popularVehicles?.length}
              slidesToShow={isTablet ? 2 : 3}
              hasNav={!isTablet && popularVehicles?.length > 3}
              id="used-car-slider-landing-popular"
            >
              {(popularVehicles as Vehicle[])?.map((vehicle, idx) => (
                <Link
                  href={getVehicleIdPath(vehicle)}
                  key={vehicle.id}
                  passHref
                  prefetch={false}
                >
                  <div key={vehicle.id}>
                    <CarTile details={vehicle} sliderTile view="tile" isPriority={idx < 3} />
                  </div>
                </Link>
              ))}
              {popularVehicles?.length >= 2 && isTablet && <div></div>}
            </SliderSlick>
          ) : (
            <div className={styles.noCars}>No vehicles available</div>
          )}
        </div>
      </BlockWrapper>
    </div>
  );
};
